import React, { useState, useEffect } from "react";
import { FileText } from "lucide-react";
import LoadingCircle from "../../components/Common/LoadingCircle";
import LandingPageHeader from "../../components/LandingPage/LandingPageHeader";
import PosterGuideCard from "../../components/PosterGuide/PosterGuideCard"; 
import PosterGuideInfo from "../../components/PosterGuide/PosterGuideInfo"; 
import { getDataByAll } from "../../api/posterApi";

const PosterGuide = ({ bgColor = "bg-white" }) => {
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    getDataByAll()
      .then((data) => {
        if (isMounted) {
          setDatas(data);
          setLoading(false);
        }
      })
      .catch(err => console.error("Error loading poster data:", err));
    
    return () => { isMounted = false; };
  }, []);

  if (loading) {
    return (
      <section id="poster-guide" className="py-20 flex flex-col items-center justify-center min-h-[400px]">
        <LoadingCircle size="lg" />
        <p className="mt-4 text-slate-400 font-mono text-[10px] uppercase tracking-widest animate-pulse">
          Retrieving Data...
        </p>
      </section>
    );
  }

  return (
    <section 
      id="poster-guide" 
      className={`pt-2 md:pt-4 pb-16 scroll-mt-28 lg:scroll-mt-52 transition-colors duration-500 ${bgColor}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header Section */}
        <div className="mb-12">
          <LandingPageHeader 
            icon={FileText} 
            title="Poster Presentation" 
            subtitle="Technical Guidelines & Submission Details" 
            center={false} 
          />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          
          {/* Sisi Kiri: Menggunakan Komponen Terpisah */}
          <PosterGuideInfo />

          {/* Sisi Kanan: Grid Poster Guide Card */}
          <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10">
            {datas.map((d, i) => (
              <PosterGuideCard 
                key={i}
                label={d.label}
                value={d.val}
                sub={d.sub}
              />
            ))}
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default PosterGuide;